import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Slide, Typography } from "@mui/material";
import { forwardRef, useState } from "react";
import BasicEdit from "./basic_edit";
import TaxEdit from "./tax_edit";
import ContactEdit from "./contact_edit";
import ShippingEdit from "./shipping_edit";


const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function ClientEdit({ client, onSuccess, onClose, open }) {
    const [isLoading, setIsLoading] = useState(false);
    const [editWarning, setEditWarning] = useState("");

    const handleSelfClose = () => {
        if (isLoading) return;
        setEditWarning("");
        onClose();
    }

    const handleOnChange = (event) => {
        if (event.status === "loading") {
            setIsLoading(true);
            setEditWarning("");
        } else if (event.status === "loaded") {
            setIsLoading(false);
            if (event.message === "change") {
                onSuccess({ ...client, ...event.change })
            } else if (event.message === "failed") {
                setEditWarning(event.error)
            } else if (event.message === "validation_error") {
                setEditWarning("");
            }
        }
    }

    if (client === null) return (<></>);
    return (
        <Dialog open={open} fullScreen onClose={handleSelfClose} TransitionComponent={Transition} keepMounted>
            <DialogTitle variant="h5" color="info">{client.name}</DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
                <Typography color="secondary" variant="body1" fontWeight={"bold"}>#{client.client_id}</Typography>
                <BasicEdit client={client} onChange={handleOnChange} />
                <TaxEdit client={client} onChange={handleOnChange} />
                <ContactEdit client={client} onChange={handleOnChange} />
                <ShippingEdit client={client} onChange={handleOnChange} />
            </DialogContent>
            {isLoading ? <LinearProgress color="secondary" /> : ""}
            <DialogActions sx={{ pb: 3, px: 3 }}>
                {editWarning === "" ? "" : <Typography variant="body2" color="error" mr={2}>{editWarning}</Typography>}
                <Button variant="outlined" disabled={isLoading} onClick={handleSelfClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}

export default ClientEdit;
